import type { StoreSchema } from '@rstore/shared';
import type { FetchFunction } from '#layers/base/public';
import { ApiKey, ApiKeyRelations } from './api-key';
import { AuditLog, AuditLogRelations } from './audit-log';
import { AuthProvider } from './auth-provider';
import { SystemEntitlementResource } from './entitlements';
import { SystemExtension } from './extension';
import { createSystemFile } from './file';
import { Invite } from './invite';
import { OrgRole } from './org-role';
import { OrgSettings } from './org-settings';
import { OrgRoleRelations, UserOrgRoleRelations } from './relations';
import {
	ServiceAccount,
	ServiceAccountRelations,
	SystemWorkspaceMember,
	SystemWorkspaceMemberRelations,
} from './service-account';
import { User, UserRelations } from './user';
import { UserOrgRole } from './user-org-role';
import { createSystemWorkspaceRelations, Workspace } from './workspace';

export function createSystemSchema(systemFetch: FetchFunction) {
	const file = createSystemFile(systemFetch);

	return [
		ApiKey,
		AuditLog,
		SystemEntitlementResource,
		SystemExtension,
		file,
		Invite,
		OrgRole,
		OrgSettings,
		ServiceAccount,
		SystemWorkspaceMember,
		User,
		UserOrgRole,
		Workspace,
		AuthProvider,
		ApiKeyRelations,
		AuditLogRelations,
		OrgRoleRelations,
		ServiceAccountRelations,
		SystemWorkspaceMemberRelations,
		UserOrgRoleRelations,
		UserRelations,
		createSystemWorkspaceRelations(file),
	] satisfies StoreSchema;
}
